import * as React from 'react';
import UserProfileView from '../layouts/UserProfileView';
import { DesignPref, DesignSofts } from 'src/reducers/userProfile';
import { ManufacturerData, TatData } from 'src/reducers/fileUpload';

export interface UserProfileProps {
  onComponentDidMount: () => void;
  onComponentWillMount: () => void;
  onSubmit: () => void;
  onSubmitDesign: () => void;
  onReset: () => void;

  updateCustomerType: (customerType: string) => void;
  updateCustomerName: (customerName: string) => void;
  updateEmail: (customerEmail: string) => void;
  updateNumber: (customerNumber: string) => void;
  updateAddressOne: (customerAddressOne: string) => void;
  updateAddressTwo: (customerAddressTwo: string) => void;
  updateCountry: (customerCountry: string) => void;
  updateState: (customerState: string) => void;
  updateProduct: (customerProduct: string) => void;
  updateScanner: (customerScanner: string) => void;
  updateContactname: (customerContactName: string) => void;
  updateContactnumber: (customerContactNumber: string) => void;
  updateComment: (customerComment: string) => void;
  updateDsoftware: (customerComment: string) => void;
  updateDestination: (customerComment: string) => void;
  updateTat: (customerComment: string) => void;
  updateOcclusion: (occlusion: string) => void;
  updateDesignType: (designtype: string) => void;
  updatePonticDesign: (Ponticdesign: string) => void;
  updateContact: (contact: string) => void;
  updateModelType: (modeltype: string) => void;
  updateNotes: (notes: string) => void;

  // typeOcclusion: Occlusiondata[];
  // saveOcclusion: (event: string) => void;

  customertype: string;
  customername: string;
  customeremail: string;
  customernumber: string;
  customeraddressone: string;
  customeraddresstwo: string;
  customercountry: string;
  customerstate: string;
  customerproduct: string;
  customerscanner: string;
  customercontactName: string;
  customercontactNumber: string;
  customercomment: string;
  custdsoft: string;
  custdest: string;
  custtat: string;

  occlusion: string;
  designType: string;
  ponticDesign: string;
  contact: string;
  modelType: string;
  notes: string;

  custname: string;
  emailid: string;
  phoneno: string;
  address1: string;
  address2: string;
  country: string;
  state: string;
  products: string;
  scanners: string;
  contactname: string;
  contactno: string;
  comments: string;
  dsoft: string;
  destination: string;
  tat: string;

  occulsionArr: DesignPref[];
  designtypeArr: DesignPref[];
  contactArr: DesignPref[];
  ponticdesignArr: DesignPref[];
  modeltypeArr: DesignPref[];

  designSoftwares: DesignSofts[];
  orderDataManufacturer: ManufacturerData[];
  orderDataTat: TatData[];
}

class UserProfile extends React.Component<UserProfileProps> {
  render() {
    return (
      <div>
        <UserProfileView
          updateCustomerType={this.props.updateCustomerType}
          updateCustomerName={this.props.updateCustomerName}
          updateEmail={this.props.updateEmail}
          updateNumber={this.props.updateNumber}
          updateAddressOne={this.props.updateAddressOne}
          updateAddressTwo={this.props.updateAddressTwo}
          updateCountry={this.props.updateCountry}
          updateState={this.props.updateState}
          updateProduct={this.props.updateProduct}
          updateScanner={this.props.updateScanner}
          updateContactname={this.props.updateContactname}
          updateContactnumber={this.props.updateContactnumber}
          updateComment={this.props.updateComment}
          updateDsoftware={this.props.updateDsoftware}
          updateDestination={this.props.updateDestination}
          updateTat={this.props.updateTat}
          updateOcclusion={this.props.updateOcclusion}
          updateDesignType={this.props.updateDesignType}
          updatePonticDesign={this.props.updatePonticDesign}
          updateContact={this.props.updateContact}
          updateModelType={this.props.updateModelType}
          updateNotes={this.props.updateNotes}
          onSubmit={this.props.onSubmit}
          onSubmitDesign={this.props.onSubmitDesign}
          onReset={this.props.onReset}

          // typeOcclusion={this.props.typeOcclusion}
          // saveOcclusion= {this.props.saveOcclusion}

          customertype={this.props.customertype}
          customername={this.props.customername}
          customeremail={this.props.customeremail}
          customernumber={this.props.customernumber}
          customeraddressone={this.props.customeraddressone}
          customeraddresstwo={this.props.customeraddresstwo}
          customercountry={this.props.customercountry}
          customerstate={this.props.customerstate}
          customerproduct={this.props.customerproduct}
          customerscanner={this.props.customerscanner}
          customercontactName={this.props.customercontactName}
          customercontactNumber={this.props.customercontactNumber}
          customercomment={this.props.customercomment}
          custdsoft={this.props.custdsoft}
          custdest={this.props.custdest}
          custtat={this.props.custtat}

          occlusion={this.props.occlusion}
          designType={this.props.designType}
          ponticDesign={this.props.ponticDesign}
          contact={this.props.contact}
          modelType={this.props.modelType}
          notes={this.props.notes}

          custname={this.props.custname}
          emailid={this.props.emailid}
          phoneno={this.props.phoneno}
          address1={this.props.address1}
          address2={this.props.address2}
          country={this.props.country}
          state={this.props.state}
          products={this.props.products}
          scanners={this.props.scanners}
          contactname={this.props.contactname}
          contactno={this.props.contactno}
          comments={this.props.comments}
          dsoft={this.props.dsoft}
          destination={this.props.destination}
          tat={this.props.tat}

          occulsionArr={this.props.occulsionArr}
          designtypeArr={this.props.designtypeArr}
          contactArr={this.props.contactArr}
          ponticdesignArr={this.props.ponticdesignArr}
          modeltypeArr={this.props.modeltypeArr}

          designSoftwares={this.props.designSoftwares}
          orderDataManufacturer={this.props.orderDataManufacturer}
          orderDataTat={this.props.orderDataTat}
        />
      </div>
    );
  }
  componentDidMount() {
    this.props.onComponentDidMount();
  }
  componentWillMount() {
    // const url: string = window.location.href;
    this.props.onComponentWillMount();
  }
}

export default UserProfile;



// WEBPACK FOOTER //
// ./src/components/userProfile/UserProfile.tsx